import Turtle from '../characters/turtle.png'
import Rabbit from '../characters/rabbit.png'

export const CHARACTER = {
	Turtle,
	Rabbit,
}



// WEBPACK FOOTER //
// ./src/constants/character.js